document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    const button = document.querySelector(".ready-to-embark-form .btn-submit");
    const colorElement = document.querySelector(".embarkBtnColor");

    if (button && colorElement) {
      const embarkBgColor = colorElement.getAttribute("embark-btn-bg-color");
      const embarkTextColor = colorElement.getAttribute(
        "embark-btn-text-color"
      );
      const embarkHoverColor = colorElement.getAttribute("embark-btn-hover-color");
      const embarkHoverTextColor = colorElement.getAttribute(
        "embark-btn-hover-text-color"
      );

      button.style.backgroundColor = embarkBgColor;
      button.style.color = embarkTextColor;

      button.addEventListener("mouseenter", function () {
        button.style.backgroundColor = embarkHoverColor;
        button.style.color = embarkHoverTextColor;
      });

      button.addEventListener("mouseleave", function () {
        button.style.backgroundColor = embarkBgColor;
        button.style.color = embarkTextColor;
      });

      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
